import { FC, useState } from "react"

interface Props {
  bbField: string
  onAdd: (crmValue: string, bbValue: string) => void
}

const ValueMappingInput: FC<Props> = ({ bbField, onAdd }) => {
  const [crmValue, setCrmValue] = useState("")
  const [bbValue, setBbValue] = useState("")

  const handleAdd = () => {
    if (crmValue && bbValue) {
      onAdd(crmValue, bbValue)
      setCrmValue("")
      setBbValue("")
    }
  }

  return (
    <div className="grid grid-cols-5 gap-2 items-center pt-2">
      <div className="col-span-2">
        <input
          type="text"
          value={crmValue}
          onChange={e => setCrmValue(e.target.value)}
          placeholder="CRM value (e.g., 'excellent')"
          className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
        />
      </div>
      <div className="col-span-2">
        <input
          type="text"
          value={bbValue}
          onChange={e => setBbValue(e.target.value)}
          placeholder="BB value (e.g., 800)"
          className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
        />
      </div>
      <div>
        <button
          type="button"
          onClick={handleAdd}
          disabled={!crmValue || !bbValue}
          className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          Add
        </button>
      </div>
    </div>
  )
}

export default ValueMappingInput
